import { render, staticRenderFns } from "./AcquisitionDetails.vue?vue&type=template&id=3c980b08&scoped=true&"
import script from "./AcquisitionDetails.vue?vue&type=script&lang=js&"
export * from "./AcquisitionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c980b08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c980b08')) {
      api.createRecord('3c980b08', component.options)
    } else {
      api.reload('3c980b08', component.options)
    }
    module.hot.accept("./AcquisitionDetails.vue?vue&type=template&id=3c980b08&scoped=true&", function () {
      api.rerender('3c980b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Affiliates/Statistics/AcquisitionDetails.vue"
export default component.exports